export default __webpack_public_path__ + "static/media/ep5collage3.97b24cf5.jpg";